import { useEffect, useRef, useState } from 'react';

const useCloseModalLineMenu = () => {
  const [showModalMenu, setShowModalMenu] = useState(false);

  const wrapperRef = useRef(null);

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setShowModalMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return {
    wrapperRef,
    showModalMenu,
    setShowModalMenu
  };
};

export default useCloseModalLineMenu;
